<template>
  <v-dialog max-width="500px" persistent v-model="show">
    <v-card tile>
      <v-card-title>
        <v-toolbar-title>Forget Password</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) => !!v || ` Email is required`,
                    (v) =>
                      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,10})+$/.test(v) ||
                      `E-mail must be valid`,
                  ]"
                  label="Email"
                  v-model="email"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="send">メール配信</v-btn>
        <v-btn @click="show = false">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      show: false,
      valid: false,
    };
  },
  methods: {
    send() {
      return this.$http
        .get("/employees/check-email?email=" + this.email)
        .then((res) => {
          if (!res.data) {
            return this.$http
              .get("/employees/reset-password?email=" + this.email)
              .then(() => {
                this.email = "";
                this.show = false;
                this.$message(
                  "",
                  "パスワード忘れの申請が完了しました、後でメールを確認し次のステップを進めてください。"
                );
                this.logoff();
              });
          } else {
            this.$message(
              "",
              "メールアドレスが間違っています。修正して下さい。"
            );
            this.logoff();
          }
        });
    },
    popup() {
      this.show = true;
    },
    logoff() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentEmployee");
      this.$store.dispatch("LOGOUT");
      this.$router.push("B0100");
    },
  },
};
</script>
